import React from "react";
import NavigationDrawer from "./../../../components/NavigationDrawer/index";
import { Grid, Typography } from "@mui/material";
import DashboardStatus from "../../../components/Dashboard/DashboardStatus";
import StatusCard from "../../../components/Dashboard/StatusCard";
import NorthIcon from "@mui/icons-material/North";
import AdmissionsGraph from "./AdmissionsGraph";
import Template from "../../../components/Dashboard/Template";
import AddmissionRequest from "./AdmissionReq";
import AdmissionRequest from "./AdmissionReq";
import NewAddmissions from "./NewAdmissions";

const cardData = [
  {
    primary: "School Rating",
    rating: 4.5,
    value: 4.5,
  },
  {
    primary: "Total Registrations",
    secondary: "1/1/24 to Today",
    value: `${5250}`,
  },
  {
    primary: "Last 30 Days Admission Fee",
    secondary: "Revenue",
    value: `$${5500}`,
  },
];

const EducationDashbaord = () => {
  return (
    <NavigationDrawer>
      <Typography
        variant="h3"
        fontSize={"1.125rem"}
        fontWeight={600}
        color={"custom.black"}
      >
        Welcome to High Public School
      </Typography>

      <DashboardStatus />

      {/* States cards */}
      <Grid container mt={2} spacing={2} mb={3}>
        {cardData?.map((val, _ind) => {
          return <StatusCard showRatings={true} item={val} index={_ind} />;
        })}
      </Grid>

      {/* Admission Graph */}

      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <AdmissionsGraph />
        </Grid>
        <Grid item xs={12} md={4}>
          <AdmissionRequest />
        </Grid>
        <Grid item xs={12}>
          <NewAddmissions />
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
};

export default EducationDashbaord;
